import { convertMoneyToUSAFormat } from '@/utils/common'

export function getVisitCreditTotal(price: number, credit: number) {
  if (credit > price) {
    return convertMoneyToUSAFormat.format(price)
  }

  return convertMoneyToUSAFormat.format(credit)
}

export function getVisitTotal(price: number, credit: number) {
  const total = price - credit
  return total < 0 ? '$0.00' : convertMoneyToUSAFormat.format(total)
}
